import styled, { css } from 'styled-components';

import { LettersBox } from '~src/shared/avatarBox/avatarBox.sc';
import { media } from '~src/styles/media-templates';


export const CardControls = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  position: relative;
  width: 100%;
`;

export const CornerButton = styled.div`
  position: absolute;
  left: 15px;
  top: 10px;
  ${media.phone`
    left: 0;
    top: 0;
  `}
`;

export const CardInfoContainer = styled.div<{$isCommentField: boolean}>`
  width: 100%;
  min-height: ${({ $isCommentField }) => ($isCommentField ? '377px' : '330px')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
  align-items: center;
  background-color: ${({ theme }) => theme.white.a10};
  border-radius: 5px 5px 0 0;
  ${media.phone`
    min-height: 319px;
    width: 100%;
  `}
`;

export const CommentSection = styled.div`
  width: 100%;
`;

export const CardAvatar = styled.div`
  display: flex;
  align-items: center;
`;

export const AvatarName = styled.div`
  margin-left: 1rem;
  font-weight: 300;
  font-size: 21px;
`;

export const CardImage = styled.div`
  ${media.phone`
    ${LettersBox} {
      height: 70px;
      width: 70px;
      font-size: 28px;
      line-height: 58px;
    }
    margin-top: 0;
  `}
`;

export const SendButton = styled.button`
  border: solid 1px ${({ theme }) => theme.white.a10};
  opacity: 0.7;
  border-radius: 5px;
  background: none;
  height: 44px;
  padding: 0 15px;
  color: ${({ theme }) => theme.white.a10};
  font-size: 12px;
  font-weight: 400;
  outline: none;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 1;
  }
`;

const calcPhoneFontSize = ($charCount: number) => {
  if ($charCount < 50) {
    return '17px';
  }
  if ($charCount > 50 && $charCount < 75) {
    return '14px';
  }
  return '12px';
};

export const CardTopicAndQuestion = styled.section<{ $charCount: number }>(
  ({ $charCount, theme }) => css`
    width: 100%;
    font-size: ${$charCount > 60 ? '16px' : '21px'};
    max-height: auto;
    font-weight: 500;
    letter-spacing: 0.3px;
    text-align: center;
    color: ${theme.baseBlue.a10};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 12px;
    ${media.phone`
      width: 100%;
      padding: 10px;
      font-size: ${calcPhoneFontSize($charCount)};
      margin-top: 10px;
      margin-bottom: 15px;
    `}
  `,
);

export const CardInfo = styled.section`
  display: flex;
  align-items: center;
  flex: 1;

  ${media.phone`
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  `}
`;

export const ScaleContainer = styled.div`
  background-image: linear-gradient(to bottom, #616885, ${({ theme }) => theme.baseBlue.a10});
  height: auto;
  min-height: 123px;
  width: 100%;
  border-radius: 0 0 4px 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  ${media.phone`
    height: auto;
    min-height: 60px;
  `}
  &.vertical {
    height: auto;
    min-height: 60px;
  }
`;

export const IconWrapper = styled.span`
  display: inline-block;
  margin-left: 5px;
  ${media.tablet`
    pointer-events: all;
  `}
`;

export const CardData = styled.div`
  display: flex;
  margin-bottom: 1.5rem;
`;

export const CardTopic = styled.div`
  color: ${({ theme }) => theme.baseBlue.a10};
  height: 4.4rem;
  opacity: 0.6;
  padding: 10px 0px;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 5px;
  align-items: center;
  line-height: 1;
  font-weight: 300;
  font-size: 21px;

  ${media.phone`
    margin-top: 5px;
    margin-right: 1rem;
  `}
`;
